   <h2 mat-dialog-title>{{ data.title | translate }}</h2>

<mat-dialog-content class="mat-typography">
  <form class="form-wrapper" [formGroup]="userinfo" autocomplete=off>

    <div class="kleineLinie">
    <mat-form-field class="datumFeld" appearance="outline" color="accent">
      <mat-label>{{ 'pages.mitarbeiterverwaltung.userinfo.gueltig' | translate }}</mat-label>
      <input
        matInput
        [placeholder]="'pages.mitarbeiterverwaltung.userinfo.gueltig' | translate"
        [matDatepicker]="picker"
        formControlName="datum"

      />
      <mat-datepicker-toggle  [tabIndex]="-1" matSuffix [for]="picker"></mat-datepicker-toggle>
      <mat-datepicker #picker></mat-datepicker>
    </mat-form-field>

    <mat-form-field class="keindatumFeld" appearance="outline" color="accent">
      <mat-label>{{ 'pages.mitarbeiterverwaltung.userinfo.prozent' | translate }}</mat-label>
      <input
        matInput
        [placeholder]="'pages.mitarbeiterverwaltung.userinfo.prozent' | translate"
        formControlName="prozent"
        [decimalNumbersOnlyMax]=100
        [kommaStellen]=2
      />
    </mat-form-field>


    </div>

    <div class="dreiEineLinie">
    <mat-form-field class="keindatumFeld" *ngIf="data.saldoZeit" appearance="outline" color="accent">
      <mat-label>{{ 'pages.mitarbeiterverwaltung.userinfo.saldoZeitLastYear' | translate }}</mat-label>
      <input
        matInput
        [placeholder]="'pages.mitarbeiterverwaltung.userinfo.saldoLastYear' | translate"
        formControlName="saldoZeit"

      />
    </mat-form-field>
    <mat-form-field class="keindatumFeld" *ngIf="data.saldoFerien" appearance="outline" color="accent">
      <mat-label>{{ 'pages.mitarbeiterverwaltung.userinfo.saldoFerienLastYear' | translate }}</mat-label>
      <input
        matInput
        [placeholder]="'pages.mitarbeiterverwaltung.userinfo.saldoFerienLastYear' | translate"
        formControlName="saldoFerien"

      />
    </mat-form-field>

    <mat-form-field class="keindatumFeld" appearance="outline" color="accent">
      <mat-label>{{ 'pages.mitarbeiterverwaltung.userinfo.ferien' | translate }}{{" " + yearFerien}}</mat-label>
      <input
        matInput
        [placeholder]="'pages.mitarbeiterverwaltung.userinfo.ferien' | translate"
        formControlName="ferien"
        [decimalNumbersOnlyMax]="100"
        [kommaStellen]="1"
      />
    </mat-form-field>
    </div>
  </form>

<!--  <app-firma-table [firmaZeiten]="$firmaZeiten | async"></app-firma-table> -->

</mat-dialog-content>

<mat-dialog-actions align="end">
  <button
    [tabIndex]="-1"
    id="abbruch"
    color="accent"
    (click)="handleCancelClick()"
  >
    {{ data.cancelButtonLabel | translate }}
  </button>
  <button
    mat-raised-button
    color="accent"
    (click)="handleSubmitClick()"
    [disabled]="userinfo.invalid"
  >
    {{ data.submitButtonLabel | translate }}
  </button>
</mat-dialog-actions>
